<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'Lifecycle'|pgettext('Contract') }}
      </strong>
      <ItpButton
        :text="'Edit...'|gettext"
        variant="light"
        size="sm"
        class="ml-auto"
        v-if="!readonly"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup
      v-if="loaded"
    >
      <ItpLabeledListGroupItem
        :label="'Contract date'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.revision_date|date"
        v-if="contract.revision_number == 0 && item.revision_date"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Revision date'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.revision_date|date"
        v-if="contract.revision_number > 0 && item.revision_date"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Validity'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.valid_from || item.valid_to"
      >
        <UcValidityPeriod
          :from="item.valid_from"
          :to="item.valid_to"
          :missingToMessage="'Indefinite'|pgettext('ContractValidity')"
        >
        </UcValidityPeriod>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Date signed'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.date_signed"
      >
        <ItpText>
          {{ item.date_signed|date}}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Effective date'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.effective_date"
      >
        <ItpText>
          {{ item.effective_date|date}}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Date of occupancy'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.date_of_occupancy"
      >
        <ItpText>
          {{ item.date_of_occupancy|date}}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Auto renewal'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.auto_renewal != null"
      >
        <ItpText>
          {{ item.auto_renewal ? gettext('On') : gettext('Off') }}
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Notice period'|pgettext('Contract')"
        :labelCols="labelCols"
        v-if="item.notice_period != null"
      >
        <ItpText>
          {{ item.notice_period }}
        </ItpText>
        <ItpText
          :text="'day(s)'|pgettext('Contract/NoticePeriod')"
        >
        </ItpText>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Indexing rule'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.indexing_rule|pgettext('IndexingRule', 'Sentence')"
        v-if="item.indexing_rule"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Next indexation date'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.next_indexation_date|date"
        v-if="item.next_indexation_date"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Terminaton date'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.termination_date|date"
        v-if="item.termination_date"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Terminaton effective date'|pgettext('Contract')"
        :labelCols="labelCols"
        :content="item.termination_effective_date|date"
        v-if="item.termination_effective_date"
      >
      </ItpLabeledListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcContractLifecycle extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  labelCols!: any;
  ux!: any;
  dataMembers = ['labelCols', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelCols: 6,
        ux: null,
      },
    }
  }

  get item() {
    if (this.loaded) {

      return this.contract.lifecycle
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_emit_9016_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_9016, alias=undefined
    return {
      event: "reload",
    }
  }

  async evh_8320016629450276_close_9015_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9015, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_9014_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9014, alias=undefined
    return {
      name: "ContractEditor",
      props: {
        target: "lifecycle",
        contract: _.cloneDeep(this.contract),
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9012: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9011: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_emit_9016: actions.EmitAction;
    evh_8320016629450276_close_9015: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9014: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9013: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9012 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9011 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9012,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9011],
      }
    );
    const act_8320016629450276_emit_9016 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_9016_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_9015 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_9016,
        event: "close",
        when: this.evh_8320016629450276_close_9015_getWhen,
        displayName: "emit",
      }
    );
    const act_8320016629450276_showModal_9014 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9014_getActionArgs,
        events: [evh_8320016629450276_close_9015],
      }
    );
    const evh_8320016629450276_clickPreventStop_9013 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9014,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9013],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9012,
      evh_7315092382398562_reload_9011,
      evh_7315092382398562_reload,
      act_8320016629450276_emit_9016,
      evh_8320016629450276_close_9015,
      act_8320016629450276_showModal_9014,
      evh_8320016629450276_clickPreventStop_9013,
      evh_8320016629450276_clickPreventStop,
    }
  }
}

Vue.component("UcContractLifecycle", UcContractLifecycle);

</script>